import {ChangeEvent, forwardRef, useRef} from "react"
import {styled} from "@mui/material/styles"
import {TextField, type TextFieldVariants, FormControl, InputAdornment, type TextFieldProps} from "@mui/material"
import NumberFormat from "react-number-format"

type AmountInputProps = {
	variant?: TextFieldVariants
	currency: string
	onChange: (event: ChangeEvent<HTMLInputElement>) => void
	classes?: {
		input: string
	}
} & Omit<TextFieldProps, "variant">

/**
 * @deprecated This component is deprecated. Please use AmountInput instead.
 */
function LegacyAmountInput(props: AmountInputProps) {
	const inputRef = useRef<HTMLDivElement>(null)
	return (
		<FormControl variant="outlined" fullWidth={true}>
			<StyledInput
				variant="outlined"
				type="text"
				autoFocus
				ref={inputRef}
				{...props}
				onChange={props.onChange}
				inputProps={{
					inputMode: "numeric",
				}}
				onClick={(event) => {
					if (event.target instanceof HTMLAnchorElement) {
						// User is clicking on support link inside the error message. We should not prevent the default behaviour
						return
					}
					event.preventDefault()
					inputRef.current?.querySelector("input")?.focus()
				}}
				InputProps={{
					startAdornment: <InputAdornment position="start">{props.currency}</InputAdornment>,
					inputComponent: LegacyNumberFormat,
					className: props?.classes?.input,
				}}
			/>
		</FormControl>
	)
}

function AmountInput(props: AmountInputProps) {
	const inputRef = useRef<HTMLDivElement>(null)
	return (
		<FormControl variant="outlined" fullWidth={true}>
			<StyledInput
				variant="outlined"
				type="text"
				autoFocus
				ref={inputRef}
				{...props}
				onChange={props.onChange}
				inputProps={{
					inputMode: "numeric",
				}}
				onClick={(event) => {
					if (event.target instanceof HTMLAnchorElement) {
						// User is clicking on support link inside the error message. We should not prevent the default behaviour
						return
					}
					event.preventDefault()
					inputRef.current?.querySelector("input")?.focus()
				}}
				InputProps={{
					startAdornment: <InputAdornment position="start">{props.currency}</InputAdornment>,
					inputComponent: NumberFormatCustom,
					className: props?.classes?.input,
				}}
			/>
		</FormControl>
	)
}

/**
 * @deprecated This component is deprecated. Please use AmountInput instead.
 */
const LegacyNumberFormat = forwardRef((props: any, inputRef) => {
	const {onChange, ...other} = props

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.floatValue,
					},
				})
			}}
			thousandSeparator={true}
			decimalScale={0}
			// Currently there is no use case for allowing negative numbers in the amount input.
			allowNegative={false}
		/>
	)
})
LegacyNumberFormat.displayName = "LegacyNumberFormat"

const NumberFormatCustom = forwardRef((props: any, inputRef) => {
	const {onChange, ...other} = props

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						name: props.name,
						value: values.floatValue,
					},
				})
			}}
			thousandSeparator={true}
			decimalScale={2}
			// Currently there is no use case for allowing negative numbers in the amount input.
			allowNegative={false}
		/>
	)
})
NumberFormatCustom.displayName = "NumberFormatCustom"

const StyledInput = styled(TextField)`
	input {
		text-align: ${({theme}) => (theme.direction === "rtl" ? "right" : "left")};
		margin-right: 3px;
		padding: 18px 0px;
		color: #474cde;
		font-weight: 600;
		font-size: 18px;
	}
`

export {LegacyAmountInput, AmountInput}
